import { render, staticRenderFns } from "./UnitOptionDetail.vue?vue&type=template&id=33a72794"
import script from "./UnitOptionDetail.vue?vue&type=script&lang=ts"
export * from "./UnitOptionDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports